import { getForms, getProgramsAccreditedsByProgramId, registerFormAnswers, getPatientByCpf, getPatientByRg, getProgramsPatientsByProgramIdRg, getProgramsPatientsByProgramIdCpf } from '@bforms-web/common';

import FormRegister, { FormRegisterProps } from '../../components/Form/GSK/PatientSpirometry/Register';

const dispatchers: FormRegisterProps = {
  getForms,
  getProgramsAccreditedsByProgramId,
  registerFormAnswers,
  getPatientByCpf,
  getPatientByRg,
  getProgramsPatientsByProgramIdRg,
  getProgramsPatientsByProgramIdCpf
};

export default function FormRegisterComposer(): JSX.Element {
  return <FormRegister {...dispatchers} />;
}
